import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { spacing, theme } from '@cc-shopping/ui/theme';
import { Box, List, Typography } from '@mui/material';
import { useRef } from 'react';
import { TocItem } from 'src/app/credit-cards/reviews/components/Body/TableOfContents/components/ListItemButton';
import { v4 } from 'uuid';
import { useTableOfContents } from './utils';
export function TableOfContents() {
  const uuidRef = useRef(v4());
  const {
    visibleSections,
    shouldDisplay
  } = useTableOfContents();
  const fireTocPageActionClick = usePageAction({
    actionName: 'review_table_of_contents',
    actionSection: '',
    actionType: 'navigate',
    parentActivityId: uuidRef.current
  });
  if (!shouldDisplay) {
    return null;
  }
  return <FeatureViewed entityName="review_table_of_contents" entitySection="" impressionPosition={0} activityId={uuidRef.current}>
      <Box sx={{
      display: {
        xs: 'none',
        md: 'block'
      },
      color: 'text.secondary',
      mt: {
        md: 6
      },
      pl: {
        md: 7.5
      }
    }}>
        <Box>
          <Typography variant="h3" sx={{
          fontWeight: theme.typography.smallerHeadline,
          fontSize: '0.875rem'
        }}>
            What&rsquo;s on This Page
          </Typography>
        </Box>
        <Box sx={{
        marginTop: spacing(1)
      }}>
          <List sx={{
          borderLeft: `1px solid ${theme.palette.grey[200]}`,
          padding: 0
        }}>
            {visibleSections.map((section, index) => {
            return <TocItem key={index} sectionID={section.id} sectionTitle={section.title} onClickAnalyticsCallback={() => {
              fireTocPageActionClick({
                actionInput: index.toString()
              });
            }} />;
          })}
          </List>
        </Box>
      </Box>
    </FeatureViewed>;
}